// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"beb95a3b","159":"2e164f16","231":"39db346c","305":"3cbe083c","377":"c8cb151e","453":"ed523043","495":"ded63956","739":"3477208d","779":"8a6176f3","861":"2f787461","924":"5179362b","932":"0749f7be"}[chunkId] + ".chunk.js";
};